import { styled } from '@mui/material';
import { FunctionComponent } from 'react';

interface Props {
  backgroundColor: string;
  color?: string;
}

const StyledDiv = styled('div')(() => ({
  borderRadius: '50%',
  textAlign: 'center',
  width: 24,
  height: 24,
}));

const CircleBadge: FunctionComponent<Props> = ({ backgroundColor }) => {
  return <StyledDiv data-testid="circle-badge" sx={{ backgroundColor }} />;
};

export default CircleBadge;
